import React from "react";
import { Stack, Banner, Container, Drawer, Flex, Inline, Input, Button, Dialog, DialogHeader, DialogContent, Card, CardActionArea, CardHeader, CardContent, Typography, Spinner, Chip, CardTitle, CardActions, Tooltip, Modal, FormControl, IconButton} from "@airbus/components-react";
import { Delete, Edit, Cancel} from "@airbus/icons/react";
import Subscription from "../models/Subscription";
import Contacts from "../models/Contacts";
import CustomMultiSelect from "../components/CustomMultiSelect";
import ModalMessageBox from "../components/ModalMessageBox";



class SubscriptionsView extends React.Component {

    constructor(){
        super();
        
        
        //states
        this.state={
            form:{newCategory:''},              //New catrgory form
            contacts:[],                        //contacts data
            categories:[],                      //categories data
            categoriesCountContacts:[],         //Number of contacts by category
            categoryDetail:null,                //Category Detail
            categoryDetailSelected:null,        // List of contacts selected in the comboBox
            open: false,                        //on true open Add category modal box
            notification: false,                //Notifications Display
            drawerDetailsOpen: false,           //Display Configuration details
            drawerDetailsAnchor:'right',        //Configuration details Position
            openModal: false,                   //Confirmation suppression modal box 
            modal_editcategory: false,          //Open Modal Category edition
            modal_selectedcategory: null,     //Edit category: selected category    
            windowWidth: window.innerWidth,     //screen width 
            windowHeight: window.innerHeight,   //screen height
            spinner: true,                      //spinner wait
            spinner_drawer: true,               //spinner drawer panel
            processing: false,                  //request in progress
        }

        //Init Subscriptions class
        this.subscriptions = new Subscription();

        //get all COntacts
        this.contacts = [];


        //Notifications properties
        this.notifVariant = null;
        this.notifMessage = null;
        this.notifDescription = null;

        //Modal Box
        this.title = null;
        this.message = null;
        this.description = null;
        this.onConfirmCallback = null;
        this.onCancelCallback = null;

        

        
    }


    /*Handle screen size*/
    handleResize = (e) => {
        this.setState({ 
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        });
    
        };


    componentDidMount = async () => {
        //Manage screen size
        window.addEventListener("resize", this.handleResize);

        //init subscriptions list
        await this.subscriptions.setCategories();
        let categories = this.subscriptions.getCategories();

        if(this.subscriptions.apiError.status !== null){
            this.notifVariant = "error";
            this.notifMessage = "Erreur Appel API";
            this.notifDescription = this.subscriptions.apiError.message;
            this.toggleNotif(true);
        }

        //init count of categories
        let countByCategory = await this.subscriptions.getCountContactsByCategory();

        if (countByCategory && countByCategory.hasOwnProperty('dataArray')){
            countByCategory = countByCategory['dataArray'];
        }else{
            countByCategory = []
        }

        if(this.subscriptions.apiError.status !== null){
            this.notifVariant = "error";
            this.notifMessage = "Erreur Appel API";
            this.notifDescription = this.subscriptions.apiError.message;
            this.toggleNotif(true);
        }



        //init contacts
        this.contacts = await new Contacts().getContacts();


        this.setState({categories:categories, categoriesCountContacts: countByCategory},
            this.setState({spinner:false})
        );
        


        

    }




    componentWillUnmount() {
        //Manage screen size
        window.addEventListener("resize", this.handleResize);
  
      }


    /**
     * RENDERING
     * @returns dom
     */
    render() { return(
        <Container style={{height:this.state.windowHeight-150, paddingTop:'10px'}}>
            
            {/* Notification*/}
            {this.state.notification ?
                <div style={{position:"fixed", width:this.state.windowWidth-90, zIndex:1000}}>
                <Banner style={{display:this.state.notification}} variant={this.notifVariant} autoHideDuration={3000}  onClose={() => this.toggleNotif(false)}>
                    <div>
                    <p>{this.notifMessage}</p>
                    {this.notifDescription !== null ?
                    <p>{this.notifDescription}</p>
                    :null}
                    </div>
                </Banner>
                <p></p>
                </div>
                
            :null}

            {/* HANDLE MODAL BOX */}
            
            <ModalMessageBox 
                title={this.title}
                message={this.message}
                description={this.description}
                open={this.state.openModal}
                onConfirmCallback={this.onConfirmCallback}
                onCancelCallback={this.onCancelCallback}

            />

           
            {/* BUTTON NEW CATEGORY */}
                <Flex justify="left">
                <Button
                    variant="primary"
                    icon={<Edit />}
                    onClick={() =>{this.onCreateCategoryClick()}}
                    >
                    Nouveau
                </Button>
                </Flex>
            
            {/**SPINNER WAIT */}
            {this.state.spinner &&
                <Flex justify="left"style={{paddingTop:"25px"}}>
                <Spinner dots/>
                </Flex>
            }

            {/* ADD NEW CATEGORY FORM */}
            <Dialog className={"AddCategoryModalBox"} 
                open={this.state.open} 
                onClose={() => this.setState({open:false})} 
                style={{minHeight:"200px", overflowY:'auto'}}
            >
                    <DialogHeader>Créer une nouvelle catégorie</DialogHeader>
                    <DialogContent >
                        <Container until="md">
                            <Flex direction="row" wrap={true}>
                                <Input 
                                        value={this.state.form.newCategory} 
                                        onChange={this.onChangeCategory} 
                                />
                            </Flex>
                        </Container>
                        <Container until="md" style={{marginTop:"10px"}}>
                            <Flex direction="row" wrap={true} style={{justifyContent:"center"}}>
                            <Button
                                style={{width:"150px"}}
                                variant="primary"
                                onClick={() =>{this.onAddCategoryClick()}}
                                disabled={this.state.processing}
                                >
                                {!this.state.processing ? "Ajouter" : "En cours..." }
                            </Button>
                            </Flex>
                        </Container>
                        <Inline spacing="2-x" align="center" >
                            
                        </Inline>
                    </DialogContent>
            </Dialog>


            {/**EDIT CATEGORY */}
            {this.state.modal_selectedcategory &&
            <Modal
                open={this.state.modal_editcategory}
                >
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 400,
                            height: 300,
                            backgroundColor: "white",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        >
                        <Stack>
                        <Inline spacing="2-x" align="center">
                            <FormControl
                                //placeholder={this.state.modal_selectedcategory.category}
                                label="Nouveau Nom"
                                style={{height:100}}
                            >  
                                <Input value={this.state.modal_selectedcategory.category} onChange={this.onChangeName} />
                            
                            </FormControl>
                        </Inline>
                        <Inline spacing="2-x" align="center">
                            <Button onClick={this.onCancelName}>
                                Annuler
                            </Button>
                            <Button onClick={this.onUpdateName}
                                variant="primary"
                                disabled={this.state.processing}
                            >{!this.state.processing ? "Sauver" : "En cours..." }
                            </Button>
                        </Inline>
                        </Stack>
                    </div>


            </Modal>
            }


             {/* DISPLAY  CATEGORIES*/}
             {this.state.categories !== null ?

                <div style={{paddingTop : "1rem"}}>
                    
                    <Flex wrap justify='left' spacing='2-x'>
                        <Typography variant="small">Cette page regroupe la liste des abonnements.
                            Les utilisateurs appartenant aux catégories "auto (site web)" reçoivent une notification 
                            automatique des nouveaux articles publiés sur le site de la SAJM. <br/>
                            D'autres listes peuvent être créées pour faciliter la diffusion via l'envoi de mail.
                        </Typography>
                    </Flex>
                    
                    <Flex wrap justify='left' spacing='2-x'>
                    
                    {this.state.categories.map((key, i)=>(
                    
                        <Card
                        style={{width:'300px', height:'180px'}}
                        key={'card-'+i}     
                        translate    
                        >
                        <CardActionArea onClick={() =>{this.onClickCategoryDetails(key.id)}}>
                            <CardHeader
                                
                                key = {'header-'+i}
                                action={key.link_wp ? 
                                    <Tooltip placement="top" label="Cette catégorie a été crée via le site web. Elle ne peut ni être modifiée ni supprimée">
                                        <Chip 
                                            variant="info" 
                                            label="auto (site web)" 
                                            size="xsmall"/>
                                    </Tooltip>
                                :null}
                            
                            />
                            <CardContent>
                                <CardTitle>
                                    {key.category}
                                </CardTitle>
                                <p>
                                    Abonnés: {this.getCategoryNumberOfContacts(key.id)}
                                </p>         
                            </CardContent>
                        </CardActionArea>
                        <CardActions>
                            {key.link_wp === null &&
                                <Inline spacing="2-x">
                                <Chip label=""
                                    icon={<Edit />}
                                    clickable
                                    variant={"warning"}
                                    onClick={() =>{this.onChangeCategoryClick(key.id)}}
                                    />

                                <Chip label=""
                                        icon={<Delete />}
                                        clickable
                                        variant={"error"}
                                        onClick={() =>{this.onDeleteCategoryClick(key.id, key.category)}}
                                        />
                                </Inline>
                            }
                        </CardActions>
                        
                        </Card>
                    

                    ))}

                    </Flex>
                    
                </div>

            :null}

            {/* CATEGORIES DETAIL DISPLAY */}
            <Drawer  open={this.state.drawerDetailsOpen} theme='light' anchor={this.state.drawerDetailsAnchor} onClose={() => this.setState({drawerDetailsOpen:false})}>
                <div  style={{
                    [this.state.drawerDetailsAnchor === "left" || this.state.drawerDetailsAnchor === "right" ? "width" : "height"]: 750,
                    paddingTop: 150,
                    overflow:'hidden',
                    maxWidth: this.state.windowWidth
                }}>
                    
                    {/**Close */}
                    <div><IconButton variant="ghost" style={{color:'red'}} onClick={()=>this.setState({drawerDetailsOpen:false})}><Cancel /></IconButton></div>
                    
                    
                    <Container>
                        {this.state.spinner_drawer &&
                            <Flex justify="left">
                                <Spinner dots/>
                            </Flex>
                        }
                    </Container>
                    
                    {this.state.categoryDetail !== null ?
                    
                    
                    <Container style={{height:this.state.windowHeight-180}}>
                        <h3>{this.state.categoryDetail.category}</h3>
                        <Stack spacing="2-x" >
                            
                            {this.state.categoryDetail.contacts.length > 0 &&
                            <CustomMultiSelect
                                mykey={Math.random()}
                                options={this.state.categoryDetail.contacts}
                                selectedValues={this.state.categoryDetailSelected}
                                displayValue={["label"]}
                                id="value"
                                groupBy="group"
                                multiple={true}
                                selectAll={true}
                                unSelectAll={true}
                                callBack={(id)=>{this.onChangeComboContacts(id, this.state.categoryDetail.id)}}
                    
                            /> 
                            }
                        </Stack>
                        
                        <Stack>
                            <Typography variant="h6">Abonnés</Typography>
                            <div style={{overflowY:"auto", height:this.state.windowHeight-400}}>
                            <ul>
                            {this.state.categoryDetailSelected !==null && this.state.categoryDetailSelected.map((contact)=>(
                                <li>{contact.label}</li>
                            ))}
                            </ul>
                            </div>
                        </Stack>
                    </Container>
                    :null}


                </div>
            </Drawer>



        </Container>
    )}
    
    /**
     * FUNCTIONS
     */
    //Compare data selected vs data stored in DB
    compareWithDBSubscription = (selected_data, db_data) =>{

        let _ = require("underscore");
        
        

        let selected_ids = _.map(selected_data, function(item){
            return item.selected_id;
        });

        let db_ids = _.map(db_data, function(item){
            return item.id;
        });

        //data to add

        let new_data = _.reject(selected_ids, function(item){
            return db_ids.includes(item)
        });


        //let's get data to remove

        let remove_data = _.reject(db_ids, function(item){
            return selected_ids.includes(item)
        });
        
        return(
            {
                'contact_ids_toremove':remove_data,
                'contact_ids_toadd':new_data,
            }
        )

    }


    /**
     * Retrieve The number of contacts
     * @param {number} categoryid list of contacts grouped by categories
     */
    getCategoryNumberOfContacts = (categoryid) => {

        let _ = require("underscore");

        let category = _.filter(this.state.categoriesCountContacts, function(item){
            return item.id_subscription === categoryid;
        });

        if(category.length === 0){
            return 0;
        }else{
            return category[0]['count'];
        }

    }


    /**
     * EVENTS
     */
    
    //onClick Create Category
    onCreateCategoryClick = () => {

        //open Modal Box
        this.setState({open:true});

    }

    //new Category Input Change handler
    onChangeCategory = (event) => {
         
        let formData = this.state.form;
        formData.newCategory = event.target.value;
        
        this.setState({form:formData});
         
     }

     onChangeCategoryClick = (category_id) =>{
        

        let _ = require("underscore");

        let selected_category = _.filter(this.state.categories, function(item){
            return item.id === category_id;
        })

        if(selected_category.length > 0){
            //selected_category = selected_category[0];
            selected_category=Object.assign({}, selected_category[0]);
            this.setState({modal_editcategory: true, modal_selectedcategory: selected_category});
        }else{
            selected_category = null;
            this.setState({modal_editcategory: false, modal_selectedcategory: selected_category});
        }

     }


     //category NAME Input Change handler
    onChangeName = (event) => {
         
        let category = this.state.modal_selectedcategory;
        category.category = event.target.value;
        
        this.setState({modal_selectedcategory:category});
         
    }


    //Update new category name in DB
    onUpdateName = async (event) => {

        let _ = require("underscore");

        this.setState({processing: true});

        await this.subscriptions.updateCategory(this.state.modal_selectedcategory.id, this.state.modal_selectedcategory.category);

        let new_category = _.filter(this.state.categories, function(item){
            return item.id === this.state.modal_selectedcategory.id;
        }, this)

        if(new_category.length > 0){
            //selected_category = selected_category[0];
            new_category[0].category = this.state.modal_selectedcategory.category;
        }    
           


        this.setState({modal_editcategory: false, modal_selectedcategory: null, processing: false});

    }


    //Cancel new category name edition
    onCancelName = (event) => {

        this.setState({modal_editcategory: false, modal_selectedcategory: null});

    }


     //User click sur  Ajoute une nouvelle catégorie
     onAddCategoryClick = async () => {

        this.setState({processing:true});

        //Add category
        await this.subscriptions.addCategory(this.state.form.newCategory);

        if(this.subscriptions.apiError.status !== null){
            this.notifVariant = "error";
            this.notifMessage = "Erreur Appel API";
            this.notifDescription = this.subscriptions.apiError.message;
            this.toggleNotif(true);
        }else{

            this.notifVariant = "success";
            this.notifMessage = "Catégorie "+ this.state.form.newCategory +" créée";
            this.notifDescription = null;
            this.toggleNotif(true);
        }


        //close Modal Box
        this.setState({open:false, processing:false});

        //Update categories
        this.setState({categories: this.subscriptions.getCategories()})

     }


     //on user click category details
     onClickCategoryDetails = async (id) => {

        //open details view
        this.setState({
            categoryDetail: null,
            categoryDetailSelected: null,
            drawerDetailsOpen: true, 
            notification: false,
            spinner_drawer:true});

        //Get details from id
        let category = await this.subscriptions.getCategoryById(id);



        //rework label values for combobox
        let _ = require("underscore");

        let combo_category = Object.assign({}, category);

        let defaultOptions = [];
        debugger;
        let contacts = _.sortBy(_.map(this.contacts, function(item){

            let label="";
            if(!(item.nom==='' && item.prenom === '')){
                label=(item.nom+" "+item.prenom).split(" ").filter(e=>e).join(" ");

                return {
                    label: label,
                    value: item.id,
                    group: 'Contacts'
                }

            }else{
                label=item.mail;

                return {
                    label: label,
                    value: item.id,
                    group: 'Contacts (mail seulement)'
                }
            }

            

        }),'label');

        combo_category.contacts = defaultOptions.concat(contacts);

        let selected_contacts = _.sortBy(_.map(category.contacts, function(item){

            let label="";
            if(!(item.nom==='' && item.prenom === '')){
                label=(item.nom+" "+item.prenom).split(" ").filter(e=>e).join(" ");

                return {
                    label: label,
                    value: item.id,
                    group: 'Contacts'
                }

            }else{
                label=item.mail;

                return {
                    label: label,
                    value: item.id,
                    group: 'Contacts (mail seulement)'
                }
            }

            

        }),'label');


        this.setState({categoryDetail:combo_category, 
                        categoryDetailSelected:selected_contacts,
                        spinner_drawer:false});
                

     }

    //onClick Create Category
    onDeleteCategoryClick = (id, name) => {


      this.title="Suppression";
      this.message="Confirmez-vous la suppression de la catégorie \""+name+"\"?";
      this.description=null;
      this.onConfirmCallback=this.onDeleteCategoryConfirm.bind(this, id);
      this.onCancelCallback=()=>{this.setState({openModal:false})}
      this.setState({openModal:true});

    }


    /**
     * On user confirm category deletion
     * @param {number} id category id
     */
    onDeleteCategoryConfirm = async (id) =>{
        //Retrieve category details
        let category = await this.subscriptions.getCategoryById(id);

        //Delete category
        await this.subscriptions.deleteCategory(id);

        if(this.subscriptions.apiError.status !== null){
            this.notifVariant = "error";
            this.notifMessage = "Erreur Appel API";
            this.notifDescription = this.subscriptions.apiError.message;
            this.toggleNotif(true);
        }else{

            this.notifVariant = "success";
            this.notifMessage = "Catégorie "+ category.category +" supprimée";
            this.toggleNotif(true);
        }

        //Update categories
        this.setState({categories: this.subscriptions.getCategories()})

        //close details view & modal confirm box
        this.setState({drawerDetailsOpen: false, openModal: false});
    }


    //On change selected contacts
    onChangeComboContacts = async (value, categoryid) => {

        
        let _ = require("underscore");
        

        if (_.findWhere(value, {'value':'selectall'}) !== undefined){
            
            //specific case "select all"
            value = Object.assign([], this.state.categoryDetail.contacts);
            value.shift(0); //remove selection "select all";

            this.setState({categoryDetailSelected:value});

        }else{
            
            //other case
            this.setState({categoryDetailSelected:value});
        }

        


        //update in DB
        //-----------

        //get selected data
        let data_selected = {
            "id_subscription_selected":this.state.categoryDetail.id,
            "id_contacts_selected":_.map(value,function(item){
                return {"selected_id":item.value}
            })
        }

        //get db_data
        let db_data = await this.subscriptions.getCategoryById(this.state.categoryDetail.id);

        

        //compare data
        let res=this.compareWithDBSubscription(data_selected.id_contacts_selected, db_data.contacts)

        await this.subscriptions.updateUsersSubscrption(this.state.categoryDetail.id, res.contact_ids_toremove, res.contact_ids_toadd);

        //Get new count contacts by category
        let countContactsCategories = await this.subscriptions.getCountContactsByCategory();
        if (countContactsCategories && countContactsCategories.hasOwnProperty('dataArray')){
            countContactsCategories = countContactsCategories['dataArray'];
        }else{
            countContactsCategories = []
        }

        this.setState({categoriesCountContacts: countContactsCategories});

    }


    //fire / close notification
    toggleNotif(val) {
        this.setState({
            notification: val
        });
      }

}

export default SubscriptionsView;